const snackbar = () => (next) => (action) => {
  // Just pass through the action, don't create a new one
  next(action);
};

export default snackbar;
